import mitt from 'mitt';
// 所有事件都是通用的

const eventBus = mitt();
export default eventBus;
export const COMMON_EVENT_NAME = {
  UPDATE_ACTIVITY: 'UPDATE_ACTIVITY',
  ACTIVITY_TIPS: 'ACTIVITY_TIPS',
  REFRESH_GOODS_LIST: 'REFRESH_GOODS_LIST',
  REFRESH_PAY_LIST: 'REFRESH_PAY_LIST',
  REFRESH_USE_VOUCHER_LIST: 'REFRESH_USE_VOUCHER_LIST',
  INIT_VOUCHER_DATA: 'INIT_VOUCHER_DATA'
};